module.exports = __webpack_public_path__ + "static/media/ALTHAR_WEB_Experiential-Event-Stand-Alone.f2e06d56.png";